import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggleNotification(event) {
    // The form will be submitted normally - this is just for visual feedback
    const toggle = event.target
    const label = toggle.closest('label')

    if (toggle.checked) {
      label.classList.add('border-gray-900', 'bg-gray-50')
      label.classList.remove('border-gray-200')
    } else {
      label.classList.remove('border-gray-900', 'bg-gray-50')
      label.classList.add('border-gray-200')
    }
  }
}
